import { useMutation } from "@apollo/client";

import { SettingsObservationTypeEditRoute_DeleteDocument } from "../mutations.generated";

export default function useSettingsObservationTypeEditRoute_Delete() {
    const [mutate, { loading, error }] = useMutation(SettingsObservationTypeEditRoute_DeleteDocument, {});

    const deleteObservationType = async (observationTypeId: string) => {
        mutate({ variables: { input: { observationTypeId } } });
    };

    return {
        loading,
        error,
        deleteObservationType,
    };
}
